import { render } from "./DashLayout.vue?vue&type=template&id=60b3032a"
import script from "./DashLayout.vue?vue&type=script&lang=js"
export * from "./DashLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__